// extracted by mini-css-extract-plugin
module.exports = {"productImage":"ProductImage_productImage__cS5d9","slideShow":"ProductImage_slideShow__pNi72","imageWrapper":"ProductImage_imageWrapper__dcoT9"};